import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useDebounce } from './useDebounce';

/** Minimum typed characters before the PRH/YTJ name search fires (#2889). */
export const PRH_SEARCH_MIN_LENGTH = 3;
export const PRH_SEARCH_DEBOUNCE_MS = 500;

export interface PrhCompany {
  businessId: string;
  name: string;
  companyForm: string | null;
  /** Present when the search payload includes an address (optional). */
  city?: string | null;
  streetAddress?: string | null;
  postalCode?: string | null;
}

interface PrhCompanySearchResponse {
  companies: PrhCompany[];
}

export function usePrhCompanySearch(name: string) {
  const debouncedName = useDebounce(name, PRH_SEARCH_DEBOUNCE_MS);
  const query = debouncedName.trim();

  return useQuery({
    queryKey: ['prh', 'companies', query],
    queryFn: () =>
      api.get<PrhCompanySearchResponse>('/prh/companies', {
        params: { name: query },
      }),
    enabled: query.length >= PRH_SEARCH_MIN_LENGTH,
    staleTime: 5 * 60 * 1000,
    retry: false,
    select: (data) => data.companies,
  });
}
